import { compose } from "ramda";
import splitFormattedCurrency from "./splitFormattedCurrency";
const currencyReplacer = (currency = "noOp", hideSymbol = false) => {
  const nonUsDollars = (replacerOne, replacerTwo, regexReplace) => (value) => {
    const replacer = !/\$/.test(value) ? replacerOne : replacerTwo;
    const newValue = value.replace(regexReplace, hideSymbol ? "" : replacer);
    return newValue;
  };
  const replacers = {
    USD: (value) => value.replace(/\$?usd?\$?/i, "$"),
    AUD: nonUsDollars("A$", "$1A$2", /(\$)?au?d?(\$)?/i),
    CAD: nonUsDollars("C$", "$1C$2", /(\$)?ca?d?(\$)?/i),
    SEK: (value) => value.replace(/sek/i, hideSymbol ? "" : "kr"),
    CHF: (value) => value.replace(/chf/i, hideSymbol ? "" : "CHF"),
    GBP: (value) => value.replace(/£?gbp?£?/i, "\xA3"),
    JPY: (value) => value.replace(/¥?jpy?¥?/i, "\xA5"),
    NOK: (value) => value.replace(/nok/i, hideSymbol ? "" : "kr"),
    DKK: (value) => value.replace(/dkk/i, hideSymbol ? "" : "kr"),
    noOp: (value) => value
  };
  return replacers[`${currency}`] || replacers.noOp;
};
const getSplittedCurrencyAsString = (hideDecimalsForIntegers) => (formattedCurrency) => {
  if (!hideDecimalsForIntegers) {
    return formattedCurrency;
  }
  const { prefix, units, decimals, suffix } = splitFormattedCurrency(formattedCurrency);
  const hideDecimals = hideDecimalsForIntegers && decimals.substring(1) === "00";
  return `${prefix || ""}${units}${!hideDecimals ? decimals : ""}${suffix || ""}`;
};
const formatCurrency = ({
  intl,
  value,
  currency,
  hideSymbol = false,
  hideDecimalsForIntegers = false
}) => {
  return compose(getSplittedCurrencyAsString(hideDecimalsForIntegers), currencyReplacer(currency, hideSymbol), () => intl.formatNumber(value, {
    style: "currency",
    currency
  }))();
};
var formatCurrency_default = formatCurrency;
export {
  currencyReplacer,
  formatCurrency_default as default
};
